/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import Swal from "sweetalert2";
import "@github/relative-time-element";
import { FaArrowRotateLeft } from "react-icons/fa6";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";

function RestoreServicio({ handleClick }) {
  const [data, setData] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const filteredData = searchValue
    ? data.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : data;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const restaurarServicio = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Seguro que desea Restaurar este registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, Restaurarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
        customClass: {
          confirmButton: "btn-amc-blue",
          cancelButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
      });

      if (result.isConfirmed) {
        await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services/restore/${id}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );
        Swal.fire("¡Restaurado!", "El servicio ha sido Restaurado.", "success");
        setUpdateTrigger(!updateTrigger);
        handleClick("Servicios");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "No se realizo ninguna accion", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extraer los componentes de la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Formatear la fecha y la hora en el formato deseado
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  };

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services/deleted`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        const sorted = res.data.data.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setData(sorted);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const getSeviceType = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_service_types`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setServiceTypes(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
    getSeviceType();
  }, [updateTrigger]);

  const getNameServiceTypes = (id) => {
    const servicio = serviceTypes.filter((data) => data.id === id);
    if (servicio.length > 0) {
      return servicio[0].name;
    }
    return id;
  };

  return (
    <>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-4">
              <div className="dataTables_length" id="dataTables_length">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                    name="datatables_length"
                    aria-controls="datatables_length"
                    className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                    onChange={showEntries}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">Registros</span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4">
              <div className="datatables_filter" id="datatables_filter">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 mt1 p-2">Buscar</span>
                  <input
                    type="search"
                    id="searchInput"
                    className="form-control form-control-sm"
                    placeholder
                    aria-controls="datatables"
                  />
                  <button className="btn-amc-blue ml-2" onClick={handleSearch}>
                    Buscar
                  </button>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "81.2031px" }}
                    >
                      ID
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "178.203px" }}
                    >
                      Nombre
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "180.766px" }}
                    >
                      Tipo de servicio
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Creado
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "159.453px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((data) => (
                    <tr key={data.id}>
                      <td>{data.id}</td>
                      <td>{data.name}</td>
                      <td>
                        {getNameServiceTypes(data.notification_service_type_id)}
                      </td>
                      <td>
                        <relative-time
                          datetime={formatDate(data.created_at)}
                          lang="es"
                        />
                      </td>
                      <td>
                        <FaArrowRotateLeft
                          color="orange"
                          onClick={() => {
                            restaurarServicio(data.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default RestoreServicio;
